export interface ExportPDFManager {
  expectedComponents: string[];
  readyComponents: string[];
  isReady: () => boolean;
}

declare global {
  interface Window {
    EXPORT_PDF: ExportPDFManager;
  }
}

export const initializeExportPDF = (): void => {
  window.EXPORT_PDF = {
    expectedComponents: [],
    readyComponents: [],
    isReady: () => {
      const { expectedComponents, readyComponents } = window.EXPORT_PDF;
      return (
        expectedComponents.length > 0 &&
        expectedComponents.length === readyComponents.length &&
        expectedComponents.every((componentId: string) => readyComponents.includes(componentId))
      );
    }
  };
};

export const addExpectedComponent = (componentId: string): void => {
  if (!window.EXPORT_PDF) {
    console.error(`Failed to add expected component "${componentId}": EXPORT_PDF is not initialized.`);
    return;
  }
  if (!window.EXPORT_PDF.expectedComponents.includes(componentId)) {
    window.EXPORT_PDF.expectedComponents.push(componentId);
  }
};

export const removeExpectedComponent = (componentId: string): void => {
  if (!window.EXPORT_PDF) {
    console.error(`Failed to remove expected component "${componentId}": EXPORT_PDF is not initialized.`);
    return;
  }
  window.EXPORT_PDF.expectedComponents = window.EXPORT_PDF.expectedComponents.filter(
    (id: string) => id !== componentId
  );
};

export const markReady = (componentId: string): void => {
  if (!window.EXPORT_PDF) {
    console.error(`Failed to mark component "${componentId}" as ready: EXPORT_PDF is not initialized.`);
    return;
  }
  if (!window.EXPORT_PDF.readyComponents.includes(componentId)) {
    window.EXPORT_PDF.readyComponents.push(componentId);
  }
};

export const markNotReady = (componentId: string): void => {
  if (!window.EXPORT_PDF) {
    console.error(`Failed to mark component "${componentId}" as not ready: EXPORT_PDF is not initialized.`);
    return;
  }
  window.EXPORT_PDF.readyComponents = window.EXPORT_PDF.readyComponents.filter((id: string) => id !== componentId);
};
